import KapInsuranceSelectPage from "./KapInsuranceSelectPage"

export default KapInsuranceSelectPage
